import DataGrid from '../manager/data-grid/index.js';
import { initPerColumnSearch, getSelectedPerColumnSearchColumns } from '../components/per-column-search.js';
import {
    SORT_KEY_TO_CELL,
    getStatusFromRow,
    getTypeFromRow,
    getValueForSearchColumn,
    getSortValue,
} from '../shared/pledges-grid-helpers.js';
import { initializeMobileFloatingBar, bindMobileFloatingBar } from '../mobile-floating-bar.js';

const MEMBER_FLOATING_BAR_ID = 'memberPledgesFloatingBar';
const FLOATING_BAR_BIND = {
    views: [
        {
            btnId: 'memberPledgesMobileSearchBtn',
            viewId: 'memberPledgesMobileSearchPanel',
            focusSelector: '#memberPledgesSearchInputMobile',
        },
    ],
    backBtnIds: ['memberPledgesMobileSearchBackBtn'],
};

const memberPerColumnSearchConfig = {
    columnKeys: ['type', 'date_pledged', 'added_by', 'pledge_amount', 'amount_due', 'campaign', 'description', 'status'],
    columnOptions: [],
    inputSelector: '#memberPledgesSearchInput',
    storageKey: 'search_box',
    gridId: 'member-pledges-grid',
};

function createSearchMatcher(query) {
    const trimmed = (query || '').trim().toLowerCase();
    if (!trimmed) {
        return () => true;
    }
    const columns = getSelectedPerColumnSearchColumns(memberPerColumnSearchConfig);
    return (row) => columns.some((colKey) => {
        const val = getValueForSearchColumn(row, colKey);
        return val && val.includes(trimmed);
    });
}

function initGrid() {
    const grid = document.getElementById('member-pledges-grid');
    if (!grid) {
        return;
    }

    initPerColumnSearch(memberPerColumnSearchConfig);

    DataGrid.init(grid, {
        storageKeyPrefix: 'member_pledges_grid',
        searchStorageKey: 'search_box',
        statusStorageKey: 'member_pledges_status',
        recurringStatusStorageKey: 'member_pledges_recurring_status',
        typeStorageKey: 'member_pledges_type',
        searchSelector: '[data-member-pledges-search]',
        statusFilterIds: [],
        recurringStatusFilterIds: [],
        typeFilterIds: [],
        getStatusFromRow,
        getTypeFromRow,
        createSearchMatcher,
        rowMatchesStatus: () => true,
        rowMatchesType: () => true,
        sortKeyToCellMap: SORT_KEY_TO_CELL,
        getSortValue,
        emptyMessage: 'No pledges or donations',
        checkboxClass: 'pledge-checkbox',
        checkboxName: 'action_check[]',
        selectAllId: 'member-pledges-all',
        defaultSortKey: 'date_pledged',
        defaultSortDir: 'desc',
        defaultPageLength: 50,
        mobilePageLength: 10,
        initGuardAttr: 'data-member-pledges-grid-init',
    });
}

function wireMemberPledgesFloatingBar() {
    const bar = document.getElementById(MEMBER_FLOATING_BAR_ID);
    if (!bar || bar.dataset.memberPledgesFloatingBound === '1') {
        return;
    }
    if (!document.getElementById('memberPledgesMobileSearchBtn')) {
        throw new Error('initMemberPledgesGrid: #memberPledgesMobileSearchBtn is required');
    }
    if (!document.getElementById('memberPledgesMobileSearchPanel')) {
        throw new Error('initMemberPledgesGrid: #memberPledgesMobileSearchPanel is required');
    }

    bar.dataset.memberPledgesFloatingBound = '1';
    initializeMobileFloatingBar(MEMBER_FLOATING_BAR_ID);
    bindMobileFloatingBar(MEMBER_FLOATING_BAR_ID, FLOATING_BAR_BIND);
}

export function initMemberPledgesGrid() {
    if (!document.getElementById('member-pledges-grid')) {
        return;
    }
    initGrid();
    wireMemberPledgesFloatingBar();
}
